import { render, staticRenderFns } from "./programmeList.vue?vue&type=template&id=4083ca0a&"
import script from "./programmeList.vue?vue&type=script&lang=js&"
export * from "./programmeList.vue?vue&type=script&lang=js&"
import style0 from "./programmeList.vue?vue&type=style&index=0&id=4083ca0a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports